import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ChatIcon from '@mui/icons-material/Chat'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import ReplyIcon from '@mui/icons-material/Reply'
import StopIcon from '@mui/icons-material/Stop'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Button, Grid, IconButton, Tooltip } from '@mui/material'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import { makeStyles, styled, withStyles } from '@mui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as componentActions from '../../../../redux/actions/chats'; // trocar pelo redux que criarei no chat
import { Styles } from '../../../../styles/material-styles'
import { PapiroConsole } from '../../../../utils/papiroConsole'
import ChatHeaderUserActionbar from './header-user-action-bar'
import ChatHeaderHistorybar from './header-user-history-bar'
import ChatHeaderRequesterHistorybar from './header-requester-history-bar'
import SimpleSelectWithConfirmationColor from './simple-with-confirmation-color'
import './styles.css'
import { ArrowBack } from '@mui/icons-material'

const StyledButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    minWidth: 0,
  },
  '& .MuiButton-startIcon': {
    marginRight: 0,
    marginLeft: 0,
  },
}));

const StyledBackButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    minWidth: 0,
    marginInline: '16px',
  },
  '& .MuiButton-startIcon': {
    marginRight: 0,
    marginLeft: 0,
  },
}))

const useStyles = makeStyles((theme) => ({
  chatInfo: {
    width: '70%',
    '@media (max-width:599.9px)': {
      width: '100%',
    },
    '@media (min-width:600px)': {
      width: '70%',
    }
  }
}));

function ChatHeader(props) {
  const classes = useStyles();
  PapiroConsole.log("props aqui 25")
  PapiroConsole.log(props)
  const { intl } = props;

  // Chamados vinculados ao chat (mais novo primeiro). O primeiro é o "ativo" — quem
  // recebe as novas mensagens como acompanhamento. FASE 1: lista vem mockada via props.
  const linkedCalledList = props.linkedCalledList || []
  const latestCalled = linkedCalledList.length > 0 ? linkedCalledList[0] : null
  const lang = (window.location.pathname.split('/')[1]) || 'pt'
  const openCalledInNewTab = (id) => window.open(`/${lang}/called-accompaniment/${id}`, '_blank')

  // Icone do provedor (WhatsApp / Instagram / Messenger / Telegram / Webchat). Fica junto do chip
  // de ID; antes ficava na action-bar com 100px e quebrava pra linha de baixo.
  const providerId = props.chats?.chat?.messageproviderid
  const providerIcon = (
    <>
            {(providerId == 2) && <WhatsAppIcon sx={{ color: '#59BC6B', fontSize: 22 }} />}
            {(providerId == 3) && <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22" height="22" viewBox="0 0 48 48">
              <radialGradient id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1" cx="19.38" cy="42.035" r="44.899" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fd5"></stop><stop offset=".328" stop-color="#ff543f"></stop><stop offset=".348" stop-color="#fc5245"></stop><stop offset=".504" stop-color="#e64771"></stop><stop offset=".643" stop-color="#d53e91"></stop><stop offset=".761" stop-color="#cc39a4"></stop><stop offset=".841" stop-color="#c837ab"></stop></radialGradient><path fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"></path><radialGradient id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2" cx="11.786" cy="5.54" r="29.813" gradientTransform="matrix(1 0 0 .6663 0 1.849)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4168c9"></stop><stop offset=".999" stop-color="#4168c9" stop-opacity="0"></stop></radialGradient><path fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"></path><path fill="#fff" d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"></path><circle cx="31.5" cy="16.5" r="1.5" fill="#fff"></circle><path fill="#fff" d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"></path>
            </svg>}
            {(providerId == 4) && <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22" height="22" viewBox="0 0 48 48">
              <path fill="#448AFF" d="M24,4C13.5,4,5,12.1,5,22c0,5.2,2.3,9.8,6,13.1V44l7.8-4.7c1.6,0.4,3.4,0.7,5.2,0.7c10.5,0,19-8.1,19-18C43,12.1,34.5,4,24,4z"></path><path fill="#FFF" d="M12 28L22 17 27 22 36 17 26 28 21 23z"></path>
            </svg>}
            {(providerId == 5) && <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22" height="22" viewBox="0 0 48 48">
              <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"></path><path fill="#fff" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"></path><path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"></path><path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"></path>
            </svg>}
            {(providerId == 6) && <ChatIcon sx={{ color: '#277afe', fontSize: 22 }} />}
    </>
  )

  const backButton = () => {
    return (
      <StyledBackButton
        variant="text"
        sx={{ color: '#000', textTransform: 'none', border: '1px solid rgba(0, 0, 0, .4)' }}
        startIcon={<ArrowBack sx={{ color: '#000', marginRight: 0, marginLeft: 0 }} />}
        onClick={() => {
          props.addCurrentChat(null)
          props.closeChat()
        }}
      />
    )
  }
  return (<div className="omnichannel-chat-header">
    <Grid container spacing={0} >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className={props.isMobile ? "omnichannel-chat-header-chat-info-root-mobile" : "omnichannel-chat-header-chat-info-root"}>
          {(props.chats && props.chats.chat && props.chats.chat.id && props.chats.chatscount > 0) && <div className={clsx('omnichannel-chat-header-chat-info', classes.chatInfo)}>
            <AccountCircleIcon className='omnichannel-chat-header-chat-info-icon' sx={{ width: '50px', height: '50px' }} />&nbsp; {props.isMobile && backButton()}<span>{props.chats.chat?.customer?.name}</span>&nbsp; {props.chats.chat?.organizationdepartament?.name && <span>&nbsp;|&nbsp;</span>} {props.chats.chat?.organizationdepartament?.name ?? ''} &nbsp;
            <Stack sx={{ marginRight: '8px' }} direction="row" spacing={1} alignItems="center">
              <Chip label={"Id: #" + props.chats.chat.id} sx={{
                borderRadius: '4px', // Define a borda retangular
              }} color="primary" />
              {providerId ? <span style={{ display: 'inline-flex', alignItems: 'center' }}>{providerIcon}</span> : null}
              {latestCalled && <Tooltip title={intl.formatMessage({ id: "linked.calleds.open.new.tab" })} arrow>
                <Chip
                  icon={<ConfirmationNumberIcon style={{ color: '#fff' }} />}
                  label={`#${latestCalled.calledId}${linkedCalledList.length > 1 ? ' +' + (linkedCalledList.length - 1) : ''}`}
                  onClick={() => openCalledInNewTab(latestCalled.calledId)}
                  sx={{ borderRadius: '4px', cursor: 'pointer', backgroundColor: '#277afe', color: '#fff', '& .MuiChip-icon': { color: '#fff' } }}
                />
              </Tooltip>}
              {latestCalled && !latestCalled.assignedUserId && (
                <Tooltip title={intl.formatMessage({ id: "self.assign.tooltip" })} arrow>
                  <IconButton size="small"
                    onClick={() => props.onSelfAssignCalled && props.onSelfAssignCalled(latestCalled.calledId)}
                    style={{ color: '#ff9800', padding: 2 }}>
                    <PersonAddAlt1Icon style={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          </div>}
          <div className="omnichannel-chat-header-user-action-bar">
            {(props.chats && props.chats.chat && props.chats.chat.id && !props.hideExtraActions) && <ChatHeaderUserActionbar />}
            {(props.chats && props.chats.chat && props.chats.chat.id && !props.hideExtraActions) && <ChatHeaderHistorybar getChatsByHistory={props.getChatsByHistory} />}
            {(props.chats && props.chats.chat && props.chats.chat.id && !props.hideExtraActions) && <ChatHeaderRequesterHistorybar openRequesterHistorySidePanel={props.openRequesterHistorySidePanel} />}
            {/* (props.chats && props.chats.chat == null) && <div style={{width:'100%'}} className="omnichannel-chat-header-chat-info"><AccountCircleIcon sx={{ width: '50px', height: '50px' }} />
                &nbsp; <SimpleAutoCompleteSearch sendfrom2talk={true} style={{width:'100%'}} label={ intl.formatMessage({ id: "keypress.search.instruction" })+" "+intl.formatMessage({ id: "requestuser" })+" (min 5 caracteres)"} options={props.customerList} stateName="customerid" 
                changeSelect={props.changeSelect} freesolo={true} selectedText={props.customerid} loading={props.loadingcustomerid} urlapi={Api.apiurlcone()+'api/customer/name/phone'}  />
              </div>*/}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="omnichannel-chat-header-attendance-info">
        <div className='omnichannel-chat-header-attendance-info-container' style={{ width: '30%' }} >
          {(props.chats && props.chats.chat && props.chats.chat.id) && <SimpleSelectWithConfirmationColor
            label=""
            isMobile={props.isMobile}
            options={props.statusList}
            changeSelect={props.changeSelect}
            newStatusValue={props.newStatusValue}
            stateName="statusupdate"
            selected={props.chats.chat && props.chats.chat.chatstatusid ? props.chats.chat.chatstatusid : 0} />
          }
        </div>
        <div className='omnichannel-chat-header-attendance-info-container' style={{ width: '100%' }} >
          {(props.chats && props.chats.chat && props.chats.chat.id) &&
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
              <SupportAgentIcon style={{ fontSize: 18, color: '#90a4ae', flexShrink: 0 }} />
              {!props.isMobile && <span style={{ fontSize: 12, color: '#b0bcc4', fontWeight: 500, flexShrink: 0 }}>Responsável:</span>}
              <Tooltip title={props.chats.chat?.assignedusername || ''} arrow>
                <span style={{ fontSize: 13, color: '#607d8b', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{props.chats.chat?.assignedusername}</span>
              </Tooltip>
            </div>
          }
        </div>
        <div className='omnichannel-chat-header-attendance-info-buttons-container'>
          {(props.chats && props.chats.chat && props.chats.chat.id) &&
            <Tooltip title={intl.formatMessage({ id: "create.called" })} arrow>
              <StyledButton
                onClick={() => props.openOrCloseCreateCalledModal()}
                variant="text"
                sx={{ color: '#000', textTransform: 'none', marginRight: '15px', border: '1px solid rgba(0, 0, 0, .4)' }}
                startIcon={<ConfirmationNumberIcon sx={{ color: '#277afe' }} />} >
              </StyledButton>
            </Tooltip>}
          {(props.chats && props.chats.chat && props.chats.chat.id && providerId == 2) &&
            <Tooltip title={intl.formatMessage({ id: "active.message.tooltip" })} arrow>
              <StyledButton
                onClick={() => props.openOrCloseActiveMessageModal()}
                variant="text"
                sx={{ color: '#000', textTransform: 'none', marginRight: '15px', border: '1px solid rgba(0, 0, 0, .4)' }}
                startIcon={<WhatsAppIcon sx={{ color: '#25D366' }} />} >
              </StyledButton>
            </Tooltip>}
          {(props.chats && props.chats.chat && props.chats.chat.id) &&
            <Tooltip title="Transferir" arrow>
              <StyledButton
                onClick={() => props.openOrCloseTransferChatModal()}
                variant="text"
                sx={{ color: '#000', textTransform: 'none', border: '1px solid rgba(0, 0, 0, .4)' }}
                startIcon={<ReplyIcon sx={{ color: '#32B847', transform: 'rotate(180deg)' }} />} >
              </StyledButton>
            </Tooltip>}
          {(props.chats && props.chats.chat && props.chats.chat.id) &&
            <Tooltip title="Finalizar" arrow>
              <StyledButton
                onClick={() => props.openOrCloseEndChatModal()}
                variant="text"
                sx={{ color: '#000', textTransform: 'none', marginLeft: '15px', border: '1px solid rgba(0, 0, 0, .4)' }}
                startIcon={<StopIcon sx={{ color: '#CE1B1B' }} />} >
              </StyledButton>
            </Tooltip>}
        </div>
      </Grid>
    </Grid>
  </div>)
}

ChatHeader.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chats: state.chats,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ChatHeader)))